import React from 'react';
import { MailIcon } from 'lucide-react';
import { BRAND, CONTACT_EMAIL, PRODUCT_NAME } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="border-t border-zinc-800 bg-zinc-950 px-5 py-12" data-id="element-189" data-mp="3racdildve2yv">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-190" data-mp="3mg82nr1hhasi">
        <div data-id="element-191" data-mp="3hgls5pd1i8ne">
          <p className="font-display text-xl font-extrabold tracking-wide text-zinc-50" data-id="element-192" data-mp="3dguur2t0cu9w">{BRAND}</p>
          <p className="font-display mt-1 text-sm font-bold uppercase tracking-widest text-zinc-300" data-id="element-193" data-mp="38hroxg57ek0v">{PRODUCT_NAME}</p>
          <p className="mt-2 text-sm text-zinc-400" data-id="element-194" data-mp="33i5ax4hjwzr0">© 2026 {BRAND} · Todos los derechos reservados.</p>
        </div>
        <div className="md:text-right" data-id="element-195" data-mp="2ykn9s09rzotk">
          <p className="text-sm text-zinc-400" data-id="element-196" data-mp="2ylopii1qkzhm">¿Tenés alguna consulta sobre el producto?</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-flex items-center gap-2 rounded text-base font-semibold text-accent transition-colors duration-150 hover:text-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-197" data-mp="11qipdigfhx1x">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="1aqzpgs627i6h" />
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </footer>;
}